export default __webpack_public_path__ + "static/media/icon-4 posilki.628ece8d.png";